import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAlerts } from "context/AlertContext";
import { services } from "services";
import { AlertSeverity } from "utils/constants/alerts.constants";
import {
  NOTIFICATIONS_CURRENT_USER_ID,
  QueryAPIKey,
} from "utils/constants/api.constants";

const useMarkAllNotifications = () => {
  const queryClient = useQueryClient();

  const { showAlert } = useAlerts();

  const { t } = useTranslation("common", {
    keyPrefix: "notifications",
  });

  const {
    status,
    error,
    isPending,
    isError,
    isSuccess,
    mutate: markAllNotificationsRead,
  } = useMutation({
    mutationFn: () =>
      services.notifications
        .markAllNotificationsRead(NOTIFICATIONS_CURRENT_USER_ID)
        .then(() => {
          showAlert({
            severity: AlertSeverity.Success,
            message: t("markAllNotificationAsReadSuccess"),
          });
          queryClient.invalidateQueries({
            queryKey: [QueryAPIKey.GetNotificationsForUser],
          });
        })
        .catch((error) => {
          showAlert({
            severity: AlertSeverity.Error,
            message: t("markAllNotificationAsReadFailure"),
          });

          throw error;
        }),
  });

  return {
    status,
    error,
    isPending,
    isError,
    isSuccess,
    markAllNotificationsRead,
  };
};

export default useMarkAllNotifications;
